import { Button, Form, Input, Spin } from 'antd';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import {
  editNetworksRequest,
  getNetworks,
} from '../../../store/actions/networks';
import styles from '../index.module.css';

const NetworkEdit = () => {
  const { id } = useParams();
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const history = useHistory();

  const networkSelect = useSelector((state) =>
    state.networks.networks.find((network) => network.id === id)
  );

  const isLoading = useSelector((state) => state.networks.loading);

  useEffect(() => {
    if (!networkSelect) {
      dispatch(getNetworks());
    }
  }, [dispatch, networkSelect]);

  const handleFinish = (values) => {
    dispatch(
      editNetworksRequest({
        id,
        body: values,
        redirection: () => {
          history.push('/admin/networks');
        },
      })
    );
  };
  if (isLoading) {
    return (
      <Spin
        size='large'
        style={{
          position: 'absolute',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%,-50%)',
        }}
      />
    );
  }
  return (
    <div className={styles['admin-content'] + ' ' + styles['network-content']}>
      <div className={styles.table__header}>
        <h3 className={styles.table__title}>Modifier un network</h3>
      </div>
      <div className={styles.form__container}>
        {networkSelect && (
          <Form
            layout='vertical'
            name='network-edit'
            initialValues={{
              name: networkSelect.name,
              vlan: networkSelect.vlan,
              mac: networkSelect.mac,
              comments: networkSelect.comments,
            }}
            onFinish={handleFinish}
          >
            <Form.Item
              name='name'
              label={t('admin.networks.edit.label.name')}
              rules={[
                {
                  required: true,
                  message: t('admin.networks.edit.validation.name'),
                },
              ]}
            >
              <Input />
            </Form.Item>

            <Form.Item
              name='vlan'
              label={t('admin.networks.edit.label.vlan')}
              rules={[
                {
                  required: true,
                  message: t('admin.networks.edit.validation.vlan'),
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              name='mac'
              label={t('admin.networks.edit.label.mac')}
              rules={[
                {
                  required: true,
                  message: t('admin.networks.edit.validation.name'),
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item name='comments' label={t('admin.networks.edit.label.comments')}>
              <Input />
            </Form.Item>

            <div className={styles.buttons__container}>
              <Link to={'/admin/networks'}>
                <Button type='link' size='large'>
                  {t('admin.networks.edit.button.cancel')}
                </Button>
              </Link>
              <Button type='primary' htmlType='submit' size='large'>
              {t('admin.networks.edit.button.submit')}
              </Button>
            </div>
          </Form>
        )}
      </div>
    </div>
  );
};

export default NetworkEdit;
